<template>
  <div class="so-data" v-disable-component="occurrence.isCompleted || !userCanEdit">
    <div v-if="occurrence.type === occType.TechnicalOccurrence">
      <TechnicalOccurrenceData :occurrence="occurrence"></TechnicalOccurrenceData>
    </div>

    <div v-if="occurrence.type === occType.Comat">
      <ComatData :occurrence="occurrence"></ComatData>
    </div>

    <div v-if="occurrence.type === occType.Diversion">
      <DiversionData :occurrence="occurrence"></DiversionData>
    </div>

    <div v-if="occurrence.type === occType.MaterialRequest">
      <MaterialRequestData ref="materialRequestdata" :id="occurrence.id"></MaterialRequestData>
    </div>
  </div>
</template>

<script lang="ts">
  import Vue from 'vue';
  import Component from 'vue-class-component';
  import { SpecialOccurrenceModule, SpecialOccurrenceStore } from '@/store/specialOccurrence';
  import {
    SpecialOccurrenceAccessLevel,
    SpecialOccurrenceTypeDto
  } from "@/apiclient/apiclient_generated";
  import TechnicalOccurrenceData from './TechnicalOccurrenceData.vue';
  import DiversionData from './DiversionData.vue';
  import ComatData from "@/components/SpecialOccurrence/Data/ComatData.vue";
  import MaterialRequestData from "@/components/SpecialOccurrence/Data/MaterialRequestData.vue";
  import RouteNames from "@/types/routeNames";

  Component.registerHooks(["beforeRouteUpdate"]);

  @Component({
    components: {
      MaterialRequestData,
      ComatData,
      TechnicalOccurrenceData,
      DiversionData
    },
  })
  export default class SpecialOccurrenceData extends Vue {
    private store: SpecialOccurrenceModule = SpecialOccurrenceStore;
    private occType = SpecialOccurrenceTypeDto;

    beforeRouteUpdate(to: any, from: any, next: any) {
      next();
      //Update Material request overview <= before route update gets triggered on the data page
      //not on the Material Request Page itself
      if (to.name == RouteNames.specialOccurrence.root && this.occurrence.type === this.occType.MaterialRequest) {
        (this.$refs.materialRequestdata as MaterialRequestData).loadData();
      }
    }

    get occurrence() {
      return this.store.currentOccurrence;
    }

    get userCanEdit() {
      return (
          this.store.currentOccurrenceUserAccessLevel == SpecialOccurrenceAccessLevel.Admin ||
          this.store.currentOccurrenceUserAccessLevel == SpecialOccurrenceAccessLevel.Editor
      );
    }
  }
</script>

<style lang="scss">
  .loadFlightsLoader {
    height: 23px !important;
    width: 23px !important;
  }

  .loadFlightsLoader > div {
    height: 23px !important;
    width: 23px !important;
  }
</style>
